
<template>
  <div class="ad-lessons-container">
    <div class="ad-lesson" v-for="(lesson, index) in lessons" @click="go2path(lesson)">
        <div class="lesson-show-title">{{lesson.title}}</div>
        <div class="lesson-show-content" :title="lesson.description">{{lesson.description}}</div>
        <div class="img-style">
          <img :src="imgs[index]">
        </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  // @import './ad-lessons.scss'
  .ad-lessons-container {
    margin: 20px 0;
    width: 100%;
    height: 114px;
    font-family: PingFangSC-Medium;
    display: flex;
    justify-content: space-between;
    .ad-lesson {
      display: inline-block;
      width: 285px;
      height: 100%;
      background: #FFFFFF;
      border-radius: 4px;
      position: relative;
      vertical-align: middle;
      cursor: pointer;
      transition: all .5s;
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0px 4px 20px 0px rgba(10, 33, 64, 0.07);
      }
      .img-style {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        position: absolute;
        right: 20px;
        top: 20px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .lesson-show-title {
        width: 161px;
        height: 24px;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(34,34,34,1);
        line-height: 24px;
        margin: 27px 10px 0 20px;
      }
      .lesson-show-content {
        width: 163px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153,153,153,1);
        line-height: 20px;
        margin: 16px 8px 27px 20px;
      }
    }
  }
</style>

<script>
  // export { default } from './ad-lessons.js'
  export default {
    data () {
      return {
        imgs: [
          require('../../../static/images/icon/login-icon/lesson_path_3.svg'),
          require('../../../static/images/icon/login-icon/lesson_path_1.svg'),
          require('../../../static/images/icon/login-icon/lesson_path_2.svg'),
          require('../../../static/images/icon/login-icon/lesson_path_4.svg')
        ],
        learningPathData: {
          more: '/academy/',
          items: [{
            title: '成长进阶',
            link: 'https://school.oceanengine.com/page/academy-security/?visitor_source=rc_source&location=ad&round=20211209',
            img_url: require('../../../static/images/icon/login-icon/lesson_path_1.svg'),
            description: '广告投放规则解析'
          }, {
            title: '行业玩法',
            link: 'https://school.oceanengine.com/premium/course/6904893616548741134/?visitor_source=ad_source&location=ad&round=ad_loginpage_tab03',
            img_url: require('../../../static/images/icon/login-icon/lesson_path_2.svg'),
            description: '广告行业案例解读'
          }, {
            title: '新手入门',
            link: 'https://school.oceanengine.com/premium/course/6904895816561852429/?visitor_source=ad_source&location=ad&round=ad_loginpage_tab01',
            img_url: require('../../../static/images/icon/login-icon/lesson_path_3.svg'),
            description: '广告产品工具介绍'
          }, {
            title: '高级运营',
            link: 'https://school.oceanengine.com/premium/course/6904903050998054926/?visitor_source=ad_source&location=ad&round=ad_loginpage_tab04',
            img_url: require('../../../static/images/icon/login-icon/lesson_path_4.svg'),
            description: '广告投放优化指南'
          }]
        }
      }
    },
    props: {
    },
    computed: {
      lessons () {
        const { items } = JSON.parse(JSON.stringify(this.learningPathData))
        const start_item = items && items.splice(2, 1)
        this.$nextTick(() => {
          $('.lesson-show-content').each((index, item) => {
            $clamp(item, {clamp: 2})
          })
        })
        return start_item && start_item.concat(items)
      }
    },
    mounted () {
    },
    methods: {
      go2path (lesson) {
        window.open(lesson.link)
      }
    }
  }
</script>
